import { Link } from "react-router-dom";

const MetaTrader5ContentThree = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade Anywhere, Anytime with MetaTrader 5</h2>
              <p>
                MT5 isn’t limited to desktops. The platform’s mobile and web
                versions ensure uninterrupted trading on iOS, Android, or
                browser-based terminals. Manage your positions, set alerts,
                analyze trends, and execute trades with precision, wherever you
                are. Enjoy a fully synchronized trading experience across all
                your devices, so your charts, settings, and orders stay
                perfectly aligned. MT5’s optimized mobile interface delivers
                fast execution and clear market visibility, even on smaller
                screens. Whether you're traveling, commuting, or away from your
                desk, you’ll always have the tools you need to stay ahead of
                market movements.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Access MT5 Anywhere
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/platforms/meta_trader_4/meta_trader_4_02.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader5ContentThree;
